import axios from 'axios';

const instance = axios.create({
  //baseURL: 'https://api-notificacao-hml.tanaescola.com:8443/api',
  baseURL: 'https://api-notificacao.tanaescola.com/api',
  //baseURL: 'http://localhost:5025/api'  
});

// Ensure Authorization header is present on app start and after HMR/reloads
try {
  instance.defaults.headers.common['x-api-key'] = 'sBOitaAyPksHrR52dKV5gWJQcfTj835pQkkI91aXyJj3Qc';
} catch (e) {
  // ignore malformed token
}

// Keep Authorization header in sync with localStorage for every request
instance.interceptors.request.use(
  (config) => {
    try {
      config.headers = config.headers || {};
    config.headers['x-api-key'] = 'sBOitaAyPksHrR52dKV5gWJQcfTj835pQkkI91aXyJj3Qc';
    } catch (e) {
      // ignore
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default instance;